import { AdornedInput, FormField, FormHelp, Label } from '@zillow/constellation-10';

import { formatInputValue } from './cashFlow';

const FIELD_CSS = {
  gridRow: 'span 3',
  gridTemplateRows: 'subgrid',
  marginBlockEnd: '400',
  '& > .c11n_label': { alignSelf: 'end' },
} as const;

type CashFlowFieldProps = {
  label: string;
  value: string;
  unit: '$' | '%' | 'years';
  error?: string;
  onChange: (value: string) => void;
};

const CashFlowField = ({ label, value, unit, error, onChange }: CashFlowFieldProps) => {
  const isCurrency = unit === '$';

  return (
    <FormField
      css={FIELD_CSS}
      error={error !== undefined}
      label={<Label>{label}</Label>}
      description={error && <FormHelp>{error}</FormHelp>}
      control={
        <AdornedInput
          input={
            <AdornedInput.Input
              inputMode="decimal"
              maxLength={15}
              value={value}
              onChange={(event) => onChange(event.target.value)}
              onBlur={() => onChange(formatInputValue(value, isCurrency))}
            />
          }
          startAdornment={isCurrency ? <AdornedInput.Adornment>$</AdornedInput.Adornment> : undefined}
          endAdornment={isCurrency ? undefined : <AdornedInput.Adornment>{unit}</AdornedInput.Adornment>}
        />
      }
    />
  );
};

export default CashFlowField;
